import { render, staticRenderFns } from "./el-field.vue?vue&type=template&id=bfc540aa&"
import script from "./el-field.vue?vue&type=script&lang=js&"
export * from "./el-field.vue?vue&type=script&lang=js&"
import style0 from "./el-field.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "el-field.vue"
export default component.exports